import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import type { HotelDetailV2Model } from "../model/hotelDetailV2.model";
import { hotelContentToHtml, hotelContentToText } from "../utils/contentText";
import ReadMoreText from "./ReadMoreText";

interface AboutSectionProps {
  hotel: HotelDetailV2Model;
}

export default function AboutSection({ hotel }: AboutSectionProps) {
  const rawContent = hotel.description || hotel.shortDescription;
  const content = hotelContentToText(rawContent);
  const htmlContent = hotelContentToHtml(rawContent);

  return (
    <section
      id="about"
      className="scroll-mt-28 rounded-2xl border border-[#e5e7eb] bg-white p-5"
    >
      <h2 className="mb-4 flex items-center gap-2 text-base font-bold text-[#1a1a2e]">
        <PhosphorIcon name="Info" size={18} className="text-primary" />
        درباره {hotel.name}
      </h2>
      {content ? (
        <>
          {/* TODO: Restore about labels after their data source is finalized. */}
          <ReadMoreText
            text={content}
            html={htmlContent}
            collapsedClassName="max-h-56 overflow-hidden"
            contentClassName="space-y-4 text-sm leading-8 text-[#4b5563] [&_a]:font-extrabold [&_a]:text-blue-600 [&_a]:no-underline [&_a:hover]:text-blue-700 [&_b]:font-extrabold [&_b]:text-[#1f2937] [&_div]:leading-8 [&_em]:text-[#374151] [&_h1]:text-lg [&_h2]:text-lg [&_h3]:text-lg [&_h4]:text-lg [&_h5]:text-lg [&_h6]:text-lg [&_h1]:font-extrabold [&_h2]:font-extrabold [&_h3]:font-extrabold [&_h4]:font-extrabold [&_h5]:font-extrabold [&_h6]:font-extrabold [&_h1]:text-primary [&_h2]:text-primary [&_h3]:text-primary [&_h4]:text-primary [&_h5]:text-primary [&_h6]:text-primary [&_li]:leading-8 [&_li]:marker:text-primary [&_ol]:list-decimal [&_ol]:space-y-2 [&_ol]:pr-5 [&_p]:leading-8 [&_strong]:font-extrabold [&_strong]:text-[#1f2937] [&_table]:mt-4 [&_table]:w-full [&_table]:overflow-hidden [&_table]:rounded-xl [&_table]:border [&_table]:border-[#e5e7eb] [&_table]:text-sm [&_tbody_tr:nth-child(even)]:bg-[#f9fafb] [&_td]:border [&_td]:border-[#e5e7eb] [&_td]:px-3 [&_td]:py-2.5 [&_th]:border [&_th]:border-[#e5e7eb] [&_th]:bg-primary/5 [&_th]:px-3 [&_th]:py-2.5 [&_th]:font-extrabold [&_th]:text-primary [&_ul]:list-disc [&_ul]:space-y-2 [&_ul]:pr-5"
          />
          <div className="mt-4 rounded-xl border-r-4 border-r-[#f59e0b] bg-[#fff8ec] p-4">
            <div className="flex items-start gap-3">
              <PhosphorIcon
                name="Lightning"
                size={18}
                className="mt-0.5 shrink-0 text-[#f59e0b]"
              />
              <div>
                <p className="text-sm font-bold text-[#92400e]">پیشنهاد ویژه</p>
                <p className="mt-0.5 text-sm leading-6 text-[#92400e]">
                  قیمت‌ها به‌صورت لحظه‌ای بررسی می‌شوند و بهترین نرخ قابل رزرو در بخش اتاق‌ها نمایش داده شده است.
                </p>
              </div>
            </div>
          </div>
        </>
      ) : (
        <EmptyContent text="توضیحی برای این هتل ثبت نشده است." />
      )}
    </section>
  );
}

export function EmptyContent({ text }: { text: string }) {
  return (
    <div className="rounded-lg bg-[#f9fafb] px-4 py-5 text-center text-sm text-[#9ca3af]">
      {text}
    </div>
  );
}
